'use client';

import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils/cn';
import { T_Pool } from '@/ts/types/T_Pool';

interface I_TokenTabsProps {
  tokens: T_Pool[];
  className?: string;
}

export function TokenTabs({ tokens, className = '' }: I_TokenTabsProps) {
  return (
    <div className={cn('overflow-x-auto w-full flex ', className)}>
      <div className="px-5 flex pt-2.5 border-b justify-between md:justify-center lg:justify-between border-base-border/20 min-w-fit w-full">
        <TabsList className="bg-transparent h-auto p-0 w-full justify-between md:justify-center lg:justify-between">
          {tokens.map(token => {
            const tokenId = token.uuid;

            return (
              <TabsTrigger
                key={tokenId}
                value={tokenId}
                className="md:px-4 md:py-2.5 px-2.5 py-2 text-base font-normal leading-normal
                         data-[state=active]:border-b-[3px] data-[state=active]:border-b-primary
                         data-[state=active]:text-primary data-[state=active]:font-bold
                         data-[state=inactive]:text-muted bg-transparent border-b-0 rounded-none
                         data-[state=active]:bg-transparent data-[state=inactive]:bg-transparent
                         focus-visible:ring-0 focus-visible:ring-offset-0"
              >
                {token.tokenSymbol}
              </TabsTrigger>
            );
          })}
        </TabsList>
      </div>
    </div>
  );
}
